import { replaceGroundingMarkersForInsertion } from "@/utility/groundingMarkers";

/** Restore review metadata from one frozen report download without touching Word. */
export function hydrateReportDownloadSections(
  frozenSections: any[],
  localSections: any[] = [],
  sectionStatus: Record<string, boolean> = {},
  deletedSections: string[] = []
): any[] {
  const localById = new Map(localSections.map((section) => [section.id, section]));
  return frozenSections
    .filter((section) => sectionStatus?.[section.settings_group_id] !== false && !deletedSections.includes(section.settings_group_id))
    .map((section) => {
      const local = localById.get(section.settings_group_id) || {};
      const taskId = section.agent_task_id || null;
      const sameTask = !Object.prototype.hasOwnProperty.call(local, "grounding_task_id") || local.grounding_task_id === taskId;
      const sameSource = taskId
        ? sameTask
        : !Object.prototype.hasOwnProperty.call(local, "chat_history_id") || local.chat_history_id === section.chat_history_id;
      const frozenDisplayContent = section.grounding
        ? replaceGroundingMarkersForInsertion(
            section.grounding.markdown || section.content,
            section.grounding.citation_numbers
          )
        : section.content;
      // Downloaded-report adoption: restore the agent task's terminal status
      // and process-update trail ONLY for the section's exact task. A
      // regenerated section (different chat history) must never inherit the
      // old task's updates or completion state. `downloadedTaskStatus` is
      // deliberately NOT `task_id` — an active-task interpretation would make
      // a finished downloaded section look like it is still generating.
      const frozenUpdates = sameTask
        ? (Array.isArray(section.agent_task_updates) ? section.agent_task_updates.slice(-30) : [])
        : [];
      return {
        id: section.settings_group_id,
        name: section.name || section.display_name,
        display_name: section.display_name,
        user_query: section.user_query,
        insertion_key: section.insertion_key,
        type: section.section_type,
        is_enabled: true,
        chat_history_id: section.chat_history_id,
        order: section.order,
        outputDecisionStatus: true,
        evalStatus: { status: "unavailable", data: null },
        fromReportDownload: true,
        ...local,
        grounding_task_id: sameTask ? taskId : local.grounding_task_id,
        grounding_available: sameTask ? Boolean(section.grounding) : Boolean(local.grounding_available),
        content: sameSource ? local.content ?? frozenDisplayContent : local.content ?? "",
        sources: sameSource ? section.sources ?? [] : local.sources ?? [],
        snapshotGrounding: sameTask ? section.grounding : null,
        // Local review decisions win; frozen state fills the fresh-download
        // gap where the local section record does not exist yet. Also checks
        // `local.agent_task_updates` from Word custom doc properties.
        agentUpdates: sameTask
          ? (Array.isArray(local.agentUpdates) && local.agentUpdates.length > 0
              ? local.agentUpdates
              : Array.isArray(local.agent_task_updates) && local.agent_task_updates.length > 0
                ? local.agent_task_updates.slice(-30)
                : Array.isArray(local.agentUpdates)
                  ? local.agentUpdates
                  : frozenUpdates)
          : [],
        downloadedTaskStatus: sameTask
          ? section.agent_task_status || local.agent_task_status || local.downloadedTaskStatus || null
          : null,
        trace_url: sameTask ? (local.trace_url || section.trace_url || null) : (local.trace_url || null),
      };
    });
}
